import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {DatePipe} from "@angular/common";
import {IAnalysisPackage} from "../irb-rebalance.model";
import {IrbCreateRebalanceService} from "@irb/irb-create-rebalance/irb-create-rebalance.service";
import {AppService} from "@irb/app.service";
import {IrbEditorsEvents, IrbRebalanceEvents} from "@irb/irb-common/events";
import {FormControl} from "@angular/forms";
import {RebalanceService} from "../rebalance.service";
import {UtilityService} from "@irb/irb-common/services/utility.service";
import {DropdownFilterComponent} from "@irb/irb-common/components/dropdown-filter/dropdown-filter.component";
import {IDropdownItem} from "@irb/irb-common/models/dropdown.model";
import {EasternTimePipe} from "@irb/irb-common/pipes/EasternTimePipe";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";

@Component({ standalone: false,
  selector: "rebalance-scheduler",
  templateUrl: "./rebalance-scheduler.component.html",
  styleUrls: ["./rebalance-scheduler.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class RebalanceSchedulerComponent implements OnInit {
  @ViewChild("IrbendDeveryMonthListDropdown") selecteveryMonthListReference: DropdownFilterComponent;
  @ViewChild("IrbendDeveryMonthWeekDayListDropdown") selecteveryMonthWeekDayListReference: DropdownFilterComponent;
  @Output() change = new EventEmitter<any>();
  @Input()
  data: IAnalysisPackage;
  // evryMonthListDropdwon: IDropdownItem;
  //evryMonthWeekDayListDropdwon: IDropdownItem;
  holidayDateList: any;
  currentSchedulerDate: any;
  endDate: any;
  isShow: boolean = false;
  recurringShow: boolean = false;
  everyDay: boolean = false;
  weekDay: boolean = false;
  monthlyScheduler: boolean = false;
  monthlySchedulerOption = '0';
  endUpDate: boolean = false;
  endafterOccureenceDate: boolean = false;
  monthlyDateNumber: boolean = false;
  monthlyDayNumber: boolean = false;
  noEndDate: boolean = false;
  endDateValidation: any;
  schedulerNotApplicable: boolean = false;
  schedulerDisable: boolean = false;
  schedulerStartDate: any = new FormControl();
  schedulerEndByDate: any = new FormControl(); // formControl should be initialized to prevent "Cannot read property '_rawValidators'" error
  nowSchedulerDisable: boolean = false;
  maxDateNumber: any;
  endOfMonthWarning: string = "";
  regex: RegExp = /^\d+$/;
  evryMonthListOptions: IDropdownItem;
  evryMonthWeekDayListOptions: IDropdownItem;
  schedulerType = 'None';
  specificDayObj: IDropdownItem ={
    value: "a specific date",
    name: "a specific date",
  };
  evryMonthList: Array<IDropdownItem> = [
    {
      value: "the first",
      name: "the 1st",
    },
    {
      value: "the 2nd",
      name: "the 2nd",
    },
    {
      value: "the 3rd",
      name: "the 3rd",
    },
    {
      value: "the 4th",
      name: "the 4th",
    },
    {
      value: "the last",
      name: "the last",
    },
  ];

  evryMonthWeekDayList: Array<IDropdownItem> = [
    {
      value: "Tue",
      name: "Tue",
    },
    {
      value: "Wed",
      name: "Wed",
    },
    {
      value: "Thu",
      name: "Thu",
    },
    {
      value: "Fri",
      name: "Fri",
    },
    {
      value: "Sat",
      name: "Sat",
    },
  ];
  toolTipStartDate: string = '';
  toolTipEndDate: string = '';

  constructor(private etp: EasternTimePipe, private datePipe: DatePipe, private crbservice: IrbCreateRebalanceService, private as: AppService, private readonly rebalanceService: RebalanceService, private us: UtilityService) {}

  ngOnInit() {
    this.getHoliDaysList(()=>{
      this.scheduleDisable();
      this.getTomorrow();
      this.scheduleDetails();
      this.getLastDayOfAMonth();
    });
  }

  scheduleDetails() {
    if (this.data.analysisId) {
      const data = JSON.parse(JSON.stringify(this.data));
      if (data !== null && data !== undefined) {
          this.processDetails(data);
      }
    } else if (this.data.scheduler) {
      setTimeout(() => {
        this.processDetails(this.data);
      }, 10);
    }
  }
  processDetails(data: any) {
    const rebsrc: string = this.rebalanceService.getRebalanceSource();
    if (data.status === "Expired") {
        this.nowSchedulerDisable = false;
        //IREBAL-40450 when edit expired schedule "save" button shows "Process" instead of "Schedule" because scheduleType becomes "AdHoc"
        //this.data.schedulerFrequency = "None";
        //this.data.scheduler.scheduleType = "Adhoc";
        this.noEndDate = false;
        this.schedulerType = 'None';
    }
    if (!this.schedulerNotApplicable && (data.schedulerFrequency === "Daily" || data.schedulerFrequency === "Weekly" || data.schedulerFrequency === "Monthly")) {
      if (!this.data.schedulerFrequency || this.data.schedulerFrequency === "None" ) this.data.schedulerFrequency = "Daily";
      this.schedulerType = 'Scheduled';
      this.recurringShow = true;
      if (rebsrc === 'Scheduled' || this.data.navigationSource == "schedulePage") {
        this.nowSchedulerDisable = true;
        this.schedulerDisable = true;
      }
      if (this.data.scheduler.monthlyRecurrenceType) {
        if (!this.data?.scheduler?.monthlyRecurrenceType || this.data.scheduler.monthlyRecurrenceType === 'a specific date') {
          this.monthlySchedulerOption = '0';
        } else {
          this.monthlySchedulerOption = '1';
          this.evryMonthListOptions = this.searchByName(this.evryMonthList, this.data.scheduler.monthlyRecurrenceType);
        }
      }
      if (this.data.scheduler.dayName) {
        this.evryMonthWeekDayListOptions = this.searchByName(this.evryMonthWeekDayList, this.data.scheduler.dayName);
      }
      
      const startDateVal = new Date(this.formatEasternDate(data.scheduler.startDate, "/"));
      this.schedulerStartDate = new FormControl(startDateVal);

      if (data.scheduler.reccuringFreqType === "Daily") {
        this.everyDay = true;
        this.data.scheduler.everyNDays = data.scheduler.everyNDays;
      }
      if (data.scheduler.reccuringFreqType === "Weekly") {
        this.everyDay = false;
        this.weekDay = true;
        this.data.scheduler.everyNWeeks = data.scheduler.everyNWeeks;
      }
      if (data.scheduler.reccuringFreqType === "Monthly") {
        this.everyDay = false;
        this.monthlyScheduler = true;
        this.data.scheduler.everyNMonths = data.scheduler.everyNMonths;
        if (data.scheduler.dateNumber !== null || data.scheduler.dateNumber !== undefined) {
          this.monthlyDateNumber = true;
          //  this.data.scheduler.dateNumber =  this.datePipe.transform(data.scheduler.dateNumber, 'dd');
        }
        if (data.scheduler.monthlyRecurrenceType === "the first" || data.scheduler.monthlyRecurrenceType === "the 2nd" || data.scheduler.monthlyRecurrenceType === "the 3rd" || data.scheduler.monthlyRecurrenceType === "the 4th" || data.scheduler.monthlyRecurrenceType === "the last") {
          this.monthlyDayNumber = true;
          this.monthlyDateNumber = false;
        }
      }
      if (data.scheduler.endDateType === "End by (date)") {
        this.endUpDate = true;
        const endDateVal = new Date(this.formatEasternDate(data.scheduler.endByDate, "/"));
        this.schedulerEndByDate = new FormControl(endDateVal);
        // this.data.scheduler.endByDate = this.datePipe.transform(this.schedulerEndByDate.value, "yyyy-MM-dd");
        const currentEasternDate: any = new Date(this.us.getEasternTime((new Date(new Date().toDateString())).getTime()));

        this.endDateValidation = data.scheduler.endByDate < currentEasternDate.getTime() ? currentEasternDate : endDateVal;
      }
      if (data.scheduler.endDateType === "End after # occurrences") {
        this.endafterOccureenceDate = true;
        this.data.scheduler.endAfterNTimes = data.scheduler.endAfterNTimes;
      }
      if (data.scheduler.endDateType === null || data.scheduler.endDateType === undefined) {
        this.noEndDate = true;
      }
    } else if (!this.schedulerNotApplicable && this.data && (this.data.navigationSource == "schedulePage" || rebsrc === 'Scheduled')) {
      this.endDateAfterValidation();
      this.schedulerType = 'Scheduled';
      this.recurringShow = true;
      this.data.scheduler.startDate = this.schedulerStartDate.value.getTime();
      this.everyDay = true;
      data.scheduler.reccuringFreqType = "Daily";
      this.data.scheduler.everyNDays = "1";

      this.data.schedulerFrequency = "Daily";
      this.nowSchedulerDisable = true;
      this.schedulerDisable = true;
      this.onChangeRecurring();
      this.data.isSysSuggestion = true;
    }
    this.as.fireEvent(IrbRebalanceEvents.SCHEDULED_REBALANCE_NOW, this.data.schedulerFrequency);
  }

  scheduleDisable() {
    if (this.data.analysisType === "Manual adjustment" || this.data.analysisType === "Covered call") {
      this.schedulerNotApplicable = true;
      this.isShow = true;
      this.recurringShow = false;
      this.weekDay = false;
      this.everyDay = false;
      this.monthlyScheduler = false;
    }
    const rebsrc: string = this.rebalanceService.getRebalanceSource();
    if (rebsrc === 'resultSummary' || rebsrc === 'Scheduled') {
      this.nowSchedulerDisable = true;
      this.schedulerDisable = true;
    }
  }

  getHoliDaysList(cbFunc: Function) {
    this.holidayDateList = [];

    this.crbservice.getVeoNonProcessingDays().subscribe((holidays: any) => {
      holidays.forEach((hd: string) => {
        if (hd) {
          this.holidayDateList.push(new Date(hd).getTime());
        }
      });
      cbFunc();
    });
  }

  myFilter = (d: Date): boolean => {
    if (!d) {
      return false;
    }
    const day = d.getDay();
    const timeOfDay: number = d.getTime();
    const passCondition = (element: any) => element === timeOfDay;
    let isHoliday = false;
    if (this.holidayDateList && this.holidayDateList.length !== 0) {
      isHoliday = this.holidayDateList.some(passCondition);
    }

    return day !== 0 && day !== 1 && !isHoliday;
  };
  
  setChainTypeEveryMonthListOptions() {
    this.selecteveryMonthListReference.set(this.evryMonthList);
  }
  setChainTypeEveryMonthWeekDayListOptions() {
    this.selecteveryMonthWeekDayListReference.set(this.evryMonthWeekDayList);
  }

  startDateChange() {
    let StartDateCHange = this.schedulerStartDate.value;
    let monthDate = StartDateCHange.getMonth() + 1;
    monthDate = monthDate < 10 ? '0' + monthDate : monthDate;
    let dateDate = StartDateCHange.getDate();
    dateDate = dateDate < 10 ? '0' + dateDate : dateDate;
    const dCreated = monthDate + '/' + dateDate + '/' + StartDateCHange.getFullYear() + ' 00:00:00 GMT-0400';
    this.toolTipStartDate = '';
    if (!StartDateCHange
        || (StartDateCHange && !this.myFilter(StartDateCHange))
        || (StartDateCHange && StartDateCHange.getTime() < this.currentSchedulerDate.getTime())) {
      this.toolTipStartDate = 'This value is out of range';
      this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, false);
      this.data.scheduler.startDate = null;
      this.endDateValidation = null;
      this.toolTipEndDate = '';
      return;
    }
    this.endDateAfterValidation();
    if (this.toolTipEndDate === '')
      this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, true);

    this.data.scheduler.startDate = new Date(dCreated).getTime();
    if (!this.schedulerEndByDate) {
      const dateStartendDateValidation = this.us.incrementDays(StartDateCHange, 1);
      this.endDateValidation = dateStartendDateValidation;
      // this.schedulerEndByDate.value = dateStartendDateValidation;
      //this.data.scheduler.endByDate = dateStartendDateValidation.getTime();
    }
    this.getLastDayOfAMonth();
    this.change.emit(true);
  }

  endDateChange() {
    //console.log("valid end date:", this.myFilter(this.schedulerEndByDate.value));
    let endDateChange = this.schedulerEndByDate.value;
    let monthDate = endDateChange.getMonth() + 1;
    monthDate = monthDate < 10 ? '0' + monthDate : monthDate;
    let dateDate = endDateChange.getDate();
    dateDate = dateDate < 10 ? '0' + dateDate : dateDate;
    const dCreated = monthDate + '/' + dateDate + '/' + endDateChange.getFullYear() + ' 00:00:00 GMT-0400';
    this.toolTipEndDate = '';
    if (!endDateChange
        || (endDateChange && !this.myFilter(endDateChange))
        || (endDateChange && this.endDateValidation && endDateChange.getTime() < this.endDateValidation.getTime())) {
      this.toolTipEndDate = 'This value is out of range';
      setTimeout(() => {
        this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, false);
      });
      this.data.scheduler.endByDate = null;
      return;
    }
    if (this.toolTipStartDate === '' && this.toolTipEndDate === '')
      this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, true);

    this.data.scheduler.endByDate = new Date(dCreated).getTime();// this.datePipe.transform(this.schedulerEndByDate.value, "yyyy-MM-dd");
    this.change.emit(true);
  }

  getTomorrow(dateToSet = new Date()) {
    //const d = new Date(this.formatEasternDate(new Date(), "/") + ' 00:00:00 GMT-0400');
    const d = new Date(dateToSet.toLocaleString('en-US', {timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'}));
    const dateStart = this.us.incrementDays(d, 1);
    if (!this.myFilter(dateStart)) {
      this.getTomorrow(dateStart);
      return
    }
    this.currentSchedulerDate = dateStart;
    this.schedulerStartDate = new FormControl(dateStart);
  }

  endDateAfterValidation() {
    this.toolTipEndDate = '';
    let StartDateCHange = this.schedulerStartDate.value;
    let monthDate = StartDateCHange.getMonth() + 1;
    monthDate = monthDate < 10 ? '0' + monthDate : monthDate;
    let dateDate = StartDateCHange.getDate();
    dateDate = dateDate < 10 ? '0' + dateDate : dateDate;
    let dCreated: any = monthDate + '/' + dateDate + '/' + StartDateCHange.getFullYear() + ' 00:00:00 GMT-0400';
    const currentEasternDate: any = new Date(this.us.getEasternTime((new Date(new Date().toDateString())).getTime()));

    if (this.data.scheduler.reccuringFreqType === "Monthly") {
      if (this.data.scheduler.endDateType === "End by (date)") {
        currentEasternDate.setHours(0,0,0,0);
        if (new Date(dCreated).getTime() < currentEasternDate.getTime()) {
          dCreated = currentEasternDate;
        }
        let dateEndBy = this.us.incrementMonths(new Date(dCreated), 1);
        while (!this.myFilter(dateEndBy)) {
          dateEndBy = this.us.incrementDays(new Date(dateEndBy), 1);
        }
        this.schedulerEndByDate = new FormControl(dateEndBy);
        this.data.scheduler.endByDate = this.schedulerEndByDate.value.getTime();
        this.endDateValidation = dateEndBy;
      }
    } else if(this.data.scheduler.reccuringFreqType === "Daily" || this.data.scheduler.reccuringFreqType === "Weekly") {
      let minDateEnd = new Date(dCreated);

      //const currentEasternDate = new Date(this.us.getEasternTime((new Date(new Date().toDateString())).getTime()));
      let dateEnd: any;
      if (minDateEnd < currentEasternDate) {
        minDateEnd = currentEasternDate;
        dateEnd = this.us.incrementDays(minDateEnd, 1);
        if (this.data.scheduler.reccuringFreqType === "Weekly")
          dateEnd = this.us.incrementDays(new Date(minDateEnd), 2);
      } else {
        dateEnd = this.us.incrementDays(new Date(dCreated), 2);
      }
      while (!this.myFilter(dateEnd)) {
        dateEnd = this.us.incrementDays(new Date(dateEnd), 1);
      }
      this.schedulerEndByDate = new FormControl(dateEnd);
      this.data.scheduler.endByDate = this.schedulerEndByDate.value.getTime();
      this.endDateValidation = dateEnd;
    }
  }
  schedulerToggle(event: MatSlideToggleChange) {
    const enabled = event?.checked;
    if (enabled) {
      this.onChangeRecurring();
    } else {
      this.onChangeOneTime();
    }
  }
  onChangeOneTime() {
    this.data.schedulerFrequency = 'None';
    this.as.fireEvent(IrbRebalanceEvents.SCHEDULED_REBALANCE_NOW, this.data.schedulerFrequency);
    this.data.scheduler.scheduleType = "Adhoc";
    this.data.scheduler.isActive = false;
    this.isShow = true;
    this.recurringShow = false;
    this.weekDay = false;
    this.everyDay = false;
    this.monthlyScheduler = false;
    this.change.emit(true);
    this.schedulerType = 'None';
    this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, true);
  }

  onChangeRecurring(doNotFireEvents?: boolean) {
    if (!this.data.schedulerFrequency || this.data.schedulerFrequency === 'None') {
      this.data.schedulerFrequency = 'Daily';
      if (!doNotFireEvents) {
        this.as.fireEvent(IrbRebalanceEvents.SCHEDULED_REBALANCE, this.data.schedulerFrequency);
      }
      this.isShow = false;
      this.recurringShow = true;
      this.data.scheduler.scheduleType = "Recurring";
      this.data.scheduler.startDate =  this.schedulerStartDate.value.getTime();
      this.data.scheduler.everyNDays = "1";
      this.data.scheduler.reccuringFreqType = "Daily";

      this.data.scheduler.monthlyRecurrenceType = "a specific date";
      this.data.scheduler.endDateType = "No End Date";
      //this.endMonthOptions = this.searchByName(this.endingOptions, this.data.scheduler.endDateType);
      this.endafterOccureenceDate = false;
      this.data.scheduler.isActive = true;
      this.data.scheduler.dayName = null;
      delete this.data.scheduler.endByDate;
      this.schedulerEndByDate = new FormControl();
      this.noEndDate = true;
      this.endUpDate = false;
      this.everyDay = true;
      this.change.emit(true);
      this.schedulerType = 'Scheduled';
      if (this.toolTipEndDate !== '' || this.toolTipStartDate !== '')
        this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, false);
    }
  }

  onDailyChange() {
    this.endDateAfterValidation();
    this.everyDay = true;
    this.data.scheduler.everyNDays = "1";
    this.weekDay = false;
    this.monthlyScheduler = false;
    this.data.scheduler.dateNumber = null;
    this.data.schedulerFrequency = "Daily"
    this.data.scheduler.everyNMonths = null;
    this.data.scheduler.everyNWeeks = null;
    this.change.emit(true);
  }
  onWeeklyChange() {
    this.endDateAfterValidation();
    this.data.scheduler.everyNWeeks = "1";
    this.data.scheduler.dateNumber = null;
    this.data.scheduler.everyNDays = null;
    this.data.scheduler.everyNMonths = null;
    this.data.schedulerFrequency = "Weekly"
    this.weekDay = true;
    this.everyDay = false;
    this.monthlyScheduler = false;
    this.data.scheduler.tuesday = false;
    this.data.scheduler.wednesday = false;
    this.data.scheduler.thursday = false;
    this.data.scheduler.friday = false;
    this.data.scheduler.saturday = false;
    this.change.emit(true);
  }
  onMonthlyChange() {
    this.data.scheduler.dayName = null;
    this.monthSelection(this.specificDayObj);
    this.endDateAfterValidation();
    this.data.schedulerFrequency = "Monthly"
    this.data.scheduler.everyNMonths = "1";
    this.data.scheduler.everyNWeeks = null;
    this.data.scheduler.everyNDays = null;
    this.monthlyScheduler = true;
    this.weekDay = false;
    this.everyDay = false;
    this.data.scheduler.tuesday = false;
    this.data.scheduler.wednesday = false;
    this.data.scheduler.thursday = false;
    this.data.scheduler.friday = false;
    this.data.scheduler.saturday = false;
    this.change.emit(true);
  }
  onMonthlySchedulerSwitch() {
    if (this.monthlySchedulerOption === '0') {
      this.evryMonthListOptions = null;
      this.evryMonthWeekDayListOptions = null;
      this.monthSelection(this.specificDayObj);
    } else {
      this.evryMonthListOptions = this.evryMonthList[0];
      this.monthSelection(this.evryMonthListOptions);
    }
  }
  endOptionChange() {
    if (this.data.scheduler.endDateType === "End by (date)") {
      this.endDateAfterValidation();
      this.endUpDate = true;
      this.noEndDate = false;
      this.data.scheduler.endAfterNTimes = null;
      this.endafterOccureenceDate = false;
      if (this.toolTipEndDate !== '' || this.toolTipStartDate !== '')
        this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, false);
    }
    if (this.data.scheduler.endDateType === "End after # occurrences") {
      this.data.scheduler.endByDate = null;
      this.schedulerEndByDate = new FormControl();
      this.endUpDate = false;
      this.noEndDate = false;
      this.endafterOccureenceDate = true;
      this.data.scheduler.endAfterNTimes = "1";
      this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, true);
    }
    if (this.data.scheduler.endDateType === "No End Date") {
      this.data.scheduler.endByDate = null;
      this.schedulerEndByDate = new FormControl();
      this.endUpDate = false;
      this.noEndDate = true;
      this.data.scheduler.endAfterNTimes = null;
      this.endafterOccureenceDate = false;
      this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, true);
    }
    this.change.emit(true);
  }
  endAfterNTimesChange(event?: any) {
    false && console.log(event);
  }
  getLastDayOfAMonth() {
    let month = this.schedulerStartDate.value.getMonth();
    var year = this.schedulerStartDate.value.getUTCFullYear();
    let maxDate = new Date(year, month + 1, 0);
    let day = maxDate.getUTCDate();
    this.maxDateNumber = day;
  }

  validateDateNumberInput() {
    const i = parseInt(this.data.scheduler.dateNumber);
    this.endOfMonthWarning = i >= 29 && i <= 31 ? "Some months have fewer than 31 days. For these months, the occurence will fall on the last business day of the month" : "";
  }

  monthSelection(s: any) {
    this.data.scheduler.monthlyRecurrenceType = s.value;

    if (s.name === "a specific date") {
      const d = new Date();
      if (d) {
        d.setHours(0,0,0,0);
      }
      d.setDate(d.getDate() + 1);
      this.data.scheduler.dateNumber = this.datePipe.transform(d, "dd");
      this.data.scheduler.dayName = null;
      this.monthlyDateNumber = true;
      this.monthlyDayNumber = false;
    } else {
      this.data.scheduler.dateNumber = null;
      this.data.scheduler.dayName = "Tue";
      this.monthlyDayNumber = true;
      this.monthlyDateNumber = false;
      this.evryMonthWeekDayListOptions = {
        value: "Tue",
        name: "Tue",
      }
    }

    this.change.emit(true);
  }

  onEveryDayList(event: any) {
    this.data.scheduler.dayName = event.name;
    this.change.emit(true);
  }

  formatEasternDate(item: any, separator: string) {
    if (item && item != null) {
      const estTime = new Date(this.etp.transform(item));
      const estMonth = estTime.getMonth() + 1;
      const estDate = estTime.getDate();
      const returnItem = "" + (estMonth < 10 ? "0" + estMonth : estMonth) + separator + (estDate < 10 ? "0" + estDate : estDate) + separator + estTime.getFullYear();
      return returnItem;
    } else {
      return "";
    }
  }

  getEasternTime(item: any) {
    const jan = new Date(new Date().getFullYear(), 0, 1);
    const jul = new Date(new Date().getFullYear(), 6, 1);
    const offSet = new Date().getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()) ? -4 : -5;
    return new Date(item + new Date().getTimezoneOffset() * 60000 + 3600000 * offSet);
  }
  private searchByName(arr: Array<IDropdownItem>, name: string) {
    if (name === 'the first') { name = 'the 1st';}
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].name === name) {
        return arr[i];
      }
    }
    return null;
  }
}
